import { api } from "./api";
import { convertToCamel } from "@lib/convertToCamel";
import { MenuItemEntityType } from "@dto/MenuItem";
import { MapLocation } from "@dto/MapLocation";
import { isNil } from "@lib/isNil";
import { BBox } from "geojson";

export const mapMarkerApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getMapMarkers: build.query<
      MapLocation[],
      {
        categoryIds: number[];
        exclusiveCategoryIds: number[];
        startDate?: null | string;
        endDate?: null | string;
        page: number;
        entityType: MenuItemEntityType;
        bbox?: BBox;
        geographicPaginationEnabled: boolean;
      }
    >({
      query: (request) => {
        const type =
          request.entityType === "Challenge" ? "Tour" : request.entityType;
        const queryParams = [`page=${request.page}`, `type=${type}`];

        if (request.categoryIds && request.categoryIds.length > 0) {
          request.categoryIds.forEach((id) => {
            queryParams.push(`category_ids[]=${encodeURIComponent(id)}`);
          });
        }

        if (request.exclusiveCategoryIds.length > 0) {
          request.exclusiveCategoryIds.forEach((id) => {
            queryParams.push(
              `exclusive_category_ids[]=${encodeURIComponent(id)}`,
            );
          });
        }

        if (request.bbox && request.geographicPaginationEnabled) {
          queryParams.push("south_west_latitude=" + request.bbox[1]);
          queryParams.push("south_west_longitude=" + request.bbox[0]);
          queryParams.push("north_east_latitude=" + request.bbox[3]);
          queryParams.push("north_east_longitude=" + request.bbox[2]);
        }

        if (
          !isNil(VisitWidget.settings.latitude) &&
          !isNil(VisitWidget.settings.longitude)
        ) {
          queryParams.push(`latitude=${VisitWidget.settings.latitude}`);
          queryParams.push(`longitude=${VisitWidget.settings.longitude}`);
          if (VisitWidget.settings.radiusMiles !== null) {
            queryParams.push(
              `radius_miles=${VisitWidget.settings.radiusMiles}`,
            );
          }
        }

        if (request.entityType === "Event") {
          queryParams.push(`start_date=${request.startDate}`);
          queryParams.push(`end_date=${request.endDate}`);
        }

        const url = `/locations/map_locations?${queryParams.join("&")}`;

        return { url: url };
      },
      transformResponse: (responseData) => {
        return convertToCamel(responseData) as MapLocation[];
      },
      providesTags: (_place, _err, request) => [
        {
          type: "MapMarker",
          categoryIds: request.categoryIds.join(","),
          exclusiveCategoryIds: request.exclusiveCategoryIds.join(","),
          entityType: request.entityType,
          startDate: request.startDate,
          endDate: request.endDate,
          page: request.page,
        },
      ],
    }),
  }),
});

export const { useGetMapMarkersQuery } = mapMarkerApi;

export const {
  endpoints: { getMapMarkers },
} = mapMarkerApi;
